import styled from 'styled-components';
import Button from '@@Components/Buttons/Button';
export const ContentWrapper = styled.div `
  display: flex; 
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  
  ${props => props.theme.mixins.mobile(`
    display: block;
  `)};

  ${props => props.reverse && 'flex-direction: row-reverse;'}
`;
export const BrandPageContainer = styled.div `
  display: inline-block;
  width: 100%;
  max-width: 1135px;
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
`;
export const ImageContainer = styled.div `
  display: flex;
  align-items: center;
  width: auto;
  min-width: 626px;
  height: 100%;

  img {
    width: 100%;
    height: auto;
  }

  ${props => props.theme.mixins.mobile(`
    flex-direction: column;
    min-width: unset;
    padding: 25px 0;
  `)}
`;
export const TextContentContainer = styled.div `
  width: 100%;
  text-align: left;
  padding-top: 15px;
  
  ${props => props.reverse ? 'padding-left: 70px;' : 'padding-right: 70px;'}

  ${props => props.theme.mixins.mobile(`
    padding-right: 15px;
    padding-left: 15px;
  `)};
`;
export const Subtitle = styled.p `
  font-size: 16px;
  line-height: 26px;
  font-weight: 400;
  margin-bottom: 5px;
`;
export const Title = styled.p `
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 40px;
`;
export const ContentContainer = styled.div `
  font-size: 16px;
  line-height: 26px;
  padding-bottom: 35px;
  ${props => props.theme.mixins.mobile('padding-bottom: 25px;')}
`;
export const StyledButton = styled(Button) `
  display: block;
  width: 250px;
  margin-bottom: 10px;
  @media (max-width: 650px) { width: 100%; }
  ${props => props.isMobile && `
    @media (min-width: 900px) { display: none }
  `}
`;
